import { render } from "./PublicationSideNav.vue.js?vue&type=template&id=6ebc0404!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSideNav.vue?vue&type=template&id=6ebc0404"
import script from "./PublicationSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSideNav.vue?vue&type=script&lang=js"
export * from "./PublicationSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/side-nav/PublicationSideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ebc0404"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ebc0404', __exports__)) {
    api.reload('6ebc0404', __exports__)
  }
  
  module.hot.accept("./PublicationSideNav.vue.js?vue&type=template&id=6ebc0404!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSideNav.vue?vue&type=template&id=6ebc0404", () => {
    api.rerender('6ebc0404', render)
  })

}


export default __exports__